import {
    getContactTypeId,
    getDataMapper,
    mapField,
    isArray,
    isFilledContact,
} from "../../../lib";
export const mapContactToServer = getDataMapper({
    id: mapField("id", Number),
    value: mapField("value"),
    confirmed: mapField("isConfirmed", Boolean),
    contact_type_id: getContactTypeId,
});

export const mapContactsToServer = (contacts) => {
    if (!isArray(contacts)) return null;

    contacts = contacts.filter(isFilledContact);

    return contacts.map((contact) => mapContactToServer(contact));
};
